import orderBy from "lodash/orderBy";

const NOOP = () => {};
const NORMALIZE = (s = "") =>
  (s || "").toString().replace(/\W+/gi, "").toUpperCase();

export default class TagLevel {
  constructor(config, index, navigator) {
    const tm = this;
    tm.index = index;
    tm.tagKind = config.tagKind || config;
    tm.title = config.title || tm.tagKind;
    tm.viewAllLabel =
      config.viewAllLabel === false
        ? false
        : config.viewAllLabel || navigator.viewAllLabel;
    tm.hideHeading = config.hideHeading || navigator.hideHeading;

    tm.navigator = navigator;
    tm.bus = navigator.bus;
    tm.tagLabel = null;
    tm.tags = [];
    tm.onLoaded = config.onLoaded || navigator.onLoaded || NOOP;
    tm.onCleared = config.onCleared || navigator.onCleared || NOOP;
    tm.onDrilledDown = config.onDrilledDown || navigator.onDrilledDown || NOOP;
    if (navigator.sortingCriteria) {
      tm.$sortMap = tm.bus
        .read(`QueryTags.json`, {
          ...navigator.sortingCriteria,
          tagKind: tm.tagKind,
          orderBy: "Position,TagLabel",
        })
        .then(({ data }) =>
          data.results.reduce(
            (r, t, i) => Object.assign(r, { [NORMALIZE(t.tagLabel)]: i }),
            {}
          )
        );
    }
  }

  getCriteria() {
    const tm = this;
    const tagCriteria = { ...tm.navigator.baseTagCriteria };
    for (var curr = tm; !!curr; curr = curr.prev) {
      if (curr.tagLabel) tagCriteria[curr.tagKind] = [curr.tagLabel];
    }
    return tagCriteria;
  }

  heading() {
    if (this.prev && this.prev.tagLabel) {
      return this.prev.tagLabel;
    }
    return this.navigator.root.tagKind;
  }

  load() {
    const tm = this;
    tm.processing = new Date();
    tm.processed = false;
    const tagCriteria = tm.getCriteria();
    return tm.bus
      .send(tm.navigator.tagTotalsUrl, {
        tagKind: tm.tagKind,
        tagCriteria,
      })
      .then(({ data }) => {
        console.debug(tm.tagKind, data.results);
        if (tm.$sortMap) {
          return tm.$sortMap.then((sortMap) =>
            orderBy(
              data.results,
              [
                (t) =>
                  sortMap[NORMALIZE(t.tagLabel)] >= 0
                    ? sortMap[NORMALIZE(t.tagLabel)]
                    : 10000,
                "tagLabel",
              ],
              ["asc", "asc"]
            )
          );
        }
        return data.results;
      })
      .then((tags) => {
        tm.tags = tags;
        tm.navigator.currentLevel = tm;
        tm.onLoaded(tm);
      })
      .finally(() => {
        tm.processing = false;
        tm.processed = new Date();
        tm.navigator.buildAccordion();
      });
  }

  clear(leaveItems = false) {
    const tm = this;
    tm.tagLabel = null;
    if (!leaveItems) tm.tags = [];
    console.debug("clear", tm.tagKind, tm.tagLabel, { leaveItems, tm });
    tm.next && tm.next.clear();
    tm.onCleared(tm);
  }

  back() {
    const tm = this;
    console.debug("back", tm.tagKind, tm.tagLabel, tm);
    if (tm.index > 0) {
      tm.clear(true);
      tm.navigator.currentLevel = tm.prev;
      tm.prev.tagLabel = null;
    }
    tm.navigator.buildAccordion();
  }

  viewAll() {
    const tm = this;
    tm.clear(true); // clear before set tagLabel
    const tagCriteria = tm.getCriteria();
    return tm.onSelected({ tagCriteria, ...tm });
  }

  select(tag) {
    const tm = this;
    if (tm.tagLabel !== tag.tagLabel) {
      tm.clear(true); // clear before set tagLabel
      tm.tagLabel = tag.tagLabel;
      if (tm.next) {
        tm.onDrilledDown(tm);
        return tm.next.load();
      } else {
        const tagCriteria = tm.getCriteria();
        return tm.onSelected({ ...tm, tagCriteria });
      }
    } else {
      tm.navigator.currentLevel = tm;
      tm.clear(true);
      tm.navigator.buildAccordion();
    }
  }

  onSelected(...args) {
    const tm = this;
    console.debug("onSelected", { tm, args });
    if (tm.navigator.stateTo) {
      const [{ tagCriteria }] = args;
      const stateParams = Object.keys(tagCriteria).reduce(
        (a, k) => Object.assign(a, { [k]: tagCriteria[k][0] }),
        Object.assign({}, tm.navigator.stateParams || {})
      );
      console.debug("onSelected.stateTo", tm.navigator.stateTo, stateParams);
      tm.navigator.$state.transitionTo(tm.navigator.stateTo, stateParams, {
        reload: true,
        inherit: false,
        notify: true,
      });
    }
    return (tm.navigator.onSelected || NOOP)(...args);
  }

  isSelected(tag) {
    const tm = this;
    return tm.tagLabel === tag.tagLabel;
  }

  getClasses(tag) {}
}
